import { XCircle } from '@sprd/sprd-component-kit/v2';
import { toast } from 'sonner';
export const MINI_BASKET_ERROR_TOAST_ID = 'mini-basket-error';
export function showMiniBasketErrorToast(message: string) {
  toast.custom(() => <div role="alert" className="pointer-events-auto flex w-full items-center gap-3 rounded-sm border-[1.5px] border-[#DC2626] bg-white/90 px-4 py-3 text-sm shadow-lg backdrop-blur-[5px]">
        <XCircle className="size-8" color="red" />
        <p className="text-neutral-900">{message}</p>
      </div>, {
    id: MINI_BASKET_ERROR_TOAST_ID,
    toasterId: 'minibasket',
    duration: 3000
  });
}